import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import ProductMarketingPromo from './components/product-marketing-promo'
import PGASeal from './images/pga-seal.png'

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: `${theme.spacing(2)}px 0px`,
  },
  card: {
    borderRadius: '8px',
    padding: `${theme.spacing(5)}px ${theme.spacing(8.5)}px`,
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(2.5)}px ${theme.spacing(2.5)}px`,
    },
  },
  logo: {
    width: '150px',
    marginBottom: theme.spacing(1.5),
  },
}))

const Shell = ({ children }) => {
  const classes = useStyles()
  return (
    <>
      <Container maxWidth="sm">
        <Box className={classes.cardContainer}>
          <Card variant="outlined" className={classes.card}>
            <a href="/">
              <img className={classes.logo} src={PGASeal} alt="PGA of America logo" />
            </a>
            {children}
            <ProductMarketingPromo />
          </Card>
        </Box>
      </Container>
    </>
  )
}

export default Shell
